import React from 'react'
import classNames from 'classnames'
import { Loader as LoaderLib } from 'react-loaders'

export default class Loader extends React.Component {
  static defaultProps = {
    fullScreen: false,
    type: 'ball-clip-rotate'
  }

  render() {
    if (!this.props.active) {
      return null
    }
    const classes = ['react-loader']
    if (this.props.fullScreen) {
      classes.push('react-loader-fullscreen modal-backdrop show')
    } else if (this.props.cover) {
      classes.push('react-loader react-loader-cover-parent')
    }

    const loaderWrapperClasses = ['loader loader-primary']
    if (this.props.small) {
      loaderWrapperClasses.push('loader loader-sm loader-default')
    }

    return (
      <div className={classNames(classes)}>
        <div className={classNames(loaderWrapperClasses)}>
          <LoaderLib
            active
            type={this.props.type}
          />
        </div>
      </div>
    )
  }
}
